/**
 * Logger utility for consistent logging throughout the application
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

// Simple check for production mode
const isProd = typeof window !== 'undefined' && window.location.hostname !== 'localhost';

class Logger {
  private isProduction: boolean;
  
  constructor() {
    this.isProduction = isProd;
  }
  
  private log(level: LogLevel, ...args: any[]): void {
    if (this.isProduction && level === 'debug') return;
    
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
    
    switch (level) {
      case 'debug':
        console.debug(prefix, ...args);
        break;
      case 'info':
        console.info(prefix, ...args);
        break;
      case 'warn':
        console.warn(prefix, ...args);
        break;
      case 'error':
        console.error(prefix, ...args);
        break;
    }
  }
  
  debug(...args: any[]): void {
    this.log('debug', ...args);
  }
  
  info(...args: any[]): void {
    this.log('info', ...args);
  }
  
  warn(...args: any[]): void {
    this.log('warn', ...args);
  }
  
  error(...args: any[]): void {
    this.log('error', ...args);
  }
}

export const logger = new Logger();
